import * as React from 'react';

import {Card} from "@mui/material";
import {styled} from "@mui/material/styles";

const StyledCard = styled(Card)(({ theme }) => ({
    border: '1px solid #eeecec',
    cursor: 'pointer',
    transition: 'all 0.3s',
    flex:1,
    '&:hover': {
        animation: 'pulseShadow 1s ease-in-out forwards',
    },

    '@keyframes pulseShadow': {
        '0%': {
            boxShadow: '0 0 0 rgba(0,0,0,0)',
        },
        '100%': {
            boxShadow: '0 0 15px rgba(0, 0, 0, 0.1)',
        }
    },
    '& .MuiCardContent-root': {
        padding: '1rem!important',
        '& .count': {
            fontSize: '1.5rem',
            fontWeight: 'bold',
            lineHeight: '35px',
            textAlign:'right',
        },
        '& .MuiAvatar-root': {
            width: '35px',
            borderRadius: '4px',
            height: '35px',
            color: 'white',
            fontSize: '12px'
        },
    }
}));


export const StatsCard = ({children, props, styles}) => {

    return (
        <StyledCard {...props} {...styles}>
            {children}
        </StyledCard>
    )
}